import * as React from "react";
import "./Homepage.css";
import { useNavigate } from "react-router-dom";
import { ArrowButton } from "../../component/button/ArrowButton";
import { transform } from "framer-motion";

const O2component = ({ setHoveredLetter, isMobile, data }) => {
  const router = useNavigate();
  return (

    <>

      {!isMobile ? (<svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 845.93 297.29"
        width="140%"
        onMouseEnter={() => setHoveredLetter("O2")}
        onMouseLeave={() => setHoveredLetter(null)}
      >
        {/* TITLE TEXT */}


        <foreignObject
          x="0.94"
          y="-8"        // match the y from your <text> transform
          width="500"      // set your desired width
          height="250"     // enough height for all lines
        >
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              fontFamily: "Proxima Nova Black, Proxima Nova",
              fontSize: "52px",        // match your <text> font size
              fontWeight: 800,
              color: data?.[0]?.titleColor,
              lineHeight: "1.05",      // adjust line spacing
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              margin: 0,
              padding: 0,
            }}
          >
            {data?.[0]?.title?.split("/n")}
          </div>
        </foreignObject>

        {/* SUBTEXT */}


        <foreignObject
          x="0"
          y="160.61"
          width="350"
          height="120"
        >
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              fontFamily: "Proxima Nova Regular",
              fontSize: "22px",
              color: "black",
              lineHeight: "1.1",
              wordWrap: "break-word",
            }}
          >
            {data?.[0]?.subTitle?.split("/n").map((line, index) => (
              <div key={index} style={{ lineHeight: "1.05" }}>
                {line}
              </div>
            ))}
          </div>
        </foreignObject>


        {/* BUTTON GROUP */}
        <g style={{ cursor: "pointer" }} onClick={() => router(data?.[0]?.buttonUrl)}>
          {/* Background rectangle (button) */}


          {/* Path or button outline (optional) */}
          <path
            d="M810.95,151.45h-206.29c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33
      c-1.49-1.49-1.49-3.9,0-5.39c1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c0.77,0.77,1.13,1.78,1.11,2.79
      c0.02,1.01-0.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0c-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33h-42.49
      c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23C845.18,166.77,829.85,151.45,810.95,151.45Z"
            style={{
              fill: data?.[0]?.buttonColor, // Make path transparent so rectangle is visible
              stroke: data?.[0]?.buttonColor,
              strokeWidth: "1.5px",
              strokeLinecap: "round",
              strokeLinejoin: "round",
            }}
          />

          {/* Text on top of the button */}
          <text
            transform="translate(643.17 193.23)"
            style={{
              fill: "#fff",
              fontFamily: "Proxima Nova Bold, 'Proxima Nova'",
              fontSize: "18.83px",
              fontWeight: 700,
              pointerEvents: "none", // Make sure text does not block rect hover
            }}
          >
            {data?.[0]?.buttonText?.split("/n").map((line, index) => (
              <tspan key={index} x="0" y={index === 0 ? "-10" : 18.83 * index - 10}>
                {line}
              </tspan>
            ))}
          </text>
          <rect
            x="580"
            y="150"
            width="250"
            height="70"
            stroke="none"
            fill="transparent"
            pointerEvents="all"
            onMouseEnter={() => setHoveredLetter("O2")}
            onMouseLeave={() => setHoveredLetter(null)}
          />
        </g>

      </svg>) : (<svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 661.56 172.02"
        width="100%"
        height="100%"
      >
        {/* KNOW MORE text */}

        {/* Arrow/path */}
        <path
          d="M626.58,102.82h-206.29c-17.62,0-32.12,13.31-34.01,30.42h42.49l-12.33-12.33c-1.49-1.49-1.49-3.9,0-5.39,1.49-1.49,3.9-1.49,5.39,0l18.75,18.75c.77.77,1.13,1.78,1.11,2.79.02,1.01-.34,2.02-1.11,2.79l-18.75,18.75c-1.49,1.49-3.9,1.49-5.39,0-1.49-1.49-1.49-3.9,0-5.39l12.33-12.33h-42.49c1.9,17.11,16.4,30.42,34.01,30.42h206.29c18.9,0,34.23-15.32,34.23-34.23h0c0-18.9-15.32-34.23-34.23-34.23Z"
          fill="none"
          stroke={data?.[0]?.buttonColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* OPTIMIZE EVERY STEP OF YOUR STUDY ABROAD text */}


        <foreignObject
          x="0.94"
          y="1.67"        // match the y from your <text> transform
          width="650"      // set your desired width
          height="200"     // enough height for all lines
        >
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              fontFamily: "Proxima Nova Black, Proxima Nova",
              fontSize: "39px",        // match your <text> font size
              fontWeight: 800,
              color: data?.[0]?.titleColor,
              lineHeight: "1",      // adjust line spacing
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              margin: 0,
              padding: 0,
            }}
          >
            {data?.[0]?.title?.split("/n")}
          </div>
        </foreignObject>

        {/* Smaller description text */}


        <foreignObject
          x="0"
          y="95.61"
          width="350"
          height="120"
        >
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              fontFamily: "Proxima Nova Regular",
              fontSize: "22px",
              color: "black",
              lineHeight: "1.1",
              wordWrap: "break-word",
            }}
          >
            {data?.[0]?.subTitle?.split("/n").map((line, index) => (
              <div key={index} style={{ lineHeight: "1.05" }}>
                {line}
              </div>
            ))}
          </div>
        </foreignObject>
        <g onClick={() => router(data?.[0]?.buttonUrl)}>
          <text
            transform="translate(458.8 144.6)"
            style={{
              fontFamily: "Proxima Nova Bold",
              fontSize: "18.83px",
              fontWeight: 700,
              fill: data?.[0]?.buttonColor,
            }}
          >
            {data?.[0]?.buttonText?.split("/n").map((line, index) => (
              <tspan key={index} x="0" y={index === 0 ? "-10" : 18.83 * index - 10}>
                {line}
              </tspan>
            ))}
          </text>
        </g>
      </svg>
      )}
    </>

  );
};

export default O2component;
